import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowLeftRotate,
  faCamera,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "../style/Asset.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";

const FormatDate = (inp) => {
  let dateformat = inp.split("T")[0];
  const date = moment(dateformat, "YYYY-MM-DD");
  return date.format("DD-MMM-YYYY");
};
const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

export default function Asset() {
  const location = useLocation();
  let passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  const [AssetList, SetAssetList] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [AssetTypeList, SetAssetTypeList] = useState([]);
  const [AssetStatus, SetAssetStatus] = useState([]);

  const [previewUrlUpdate, setPreviewUrlUpdate] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  const [isDateInput, setIsDateInput] = useState([]);

  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const filteredAssetList = searchQuery
    ? AssetList.filter((item) =>
        item.Asset_Name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : AssetList;

  const InitState = {
    assetName: null,
    assetType: null,
    quantity: null,
    price: null,
    purchasedDate: null,
    description: null,
    invoiceNumber: null,
    expiredDate: null,
    purchasedBy: null,
    assetStatus: null,
    AssetPhoto: "",
    user: username,
  };

  const [formData, setFormData] = useState(InitState);

  const fetchAssetList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/asset/FetchAssetList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      console.log("Fetched data:", response.data);// Log the fetched data
      SetAssetList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const fetchAssetTypeList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Asset_Type`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetAssetTypeList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const fetchAssetStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Asset_Status`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetAssetStatus(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchAssetList();
    fetchAssetTypeList();
    fetchAssetStatus();
    const isText = Array(1).fill(false);
    setIsDateInput(isText);
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, [1]);

  const handleFocus = (index) => {
    const isText = [...isDateInput];
    isText[index] = true;
    setIsDateInput(isText);
  };

  const handleFocus1 = (index) => {
    const isText = [...isDateInput];
    isText[index] = false;
    setIsDateInput(isText);
  };

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleEdit = (Asset) => {
    const InitStateEdit = {
      Asset_Id: Asset.Asset_Id,
      assetName: Asset.Asset_Name,
      assetType: Asset.Asset_Type,
      quantity: Asset.Quantity,
      price: Asset.Price,
      purchasedDate:
        Asset.Purchased_Date == null
          ? null
          : convert(Asset.Purchased_Date.toString()),
      description: Asset.Description,
      invoiceNumber: Asset.Invoice_No,
      expiredDate:
        Asset.Expired_Date == null
          ? null
          : convert(Asset.Expired_Date.toString()),
      purchasedBy: Asset.Purchased_By,
      assetStatus: Asset.Asset_Status,
      AssetPhoto: "",
      assetPhoto: Asset.Asset_Photo,
    };
    setSelectedAsset(InitStateEdit);
    //console.log(InitStateEdit)
    setModalIsOpen(true);
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if(confirmClose){
      setModalIsOpen(false);
    setFormData(InitState);
    setSelectedAsset(null);
    }
    
  };

  const handleUpdateFileChange = (e) => {
    const value = e.target.files[0];
    setSelectedAsset({
      ...selectedAsset,
      AssetPhoto: value,
    });
    //console.log("======================",selectedAsset.AssetPhoto)
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewUrlUpdate(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
    //console.log("photo",e.target.files[0]);
  };

  const handleFileChange = (e) => {
    const value = e.target.files[0];
    setFormData({
      ...formData,
      AssetPhoto: value,
    });
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
    //console.log("photo",e.target.files[0]);
  };

  const handleChangeDate = (e, index) => {
    const { name, value } = e.target;
    let date = new Date(e.target.value);
    //console.log((convert(date)))
    if (!isNaN(date)) {
      setFormData({
        ...formData,
        [name]: convert(date),
      });
    }
  };
  const handleUpdateDate = (e, index) => {
    const { name, value } = e.target;
    let date = new Date(e.target.value);
    //console.log((convert(date)))
    if (!isNaN(date)) {
      setSelectedAsset({
        ...selectedAsset,
        [name]: convert(date),
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name,value);
    const pattern = /[^a-zA-Z0-9 ]/g;
    if (name === "assetName") {
      let result = pattern.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.replace(/[^a-zA-Z0-9\s]/g, "").toUpperCase(),
        });
      }
    } else if (name === "invoiceNumber") {
      setFormData({
        ...formData,
        [name]: value
          .replace(/[^A-Za-z0-9-/]/g, "")
          .trim()
          .toUpperCase()
          .slice(0, 15),
      });
    } else if (name === "purchasedBy") {
      setFormData({
        ...formData,
        [name]: value
          .replace(/[^a-zA-Z\s]/g, "")
          .replace(/\s+/g, " ")
          .trim()
          .toUpperCase(),
      });
    } else if (name === "quantity" || name === "price") {
      setFormData({
        ...formData,
        [name]: value.replace(/[^0-9]/g, "").slice(0, 8),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z0-9 ]/g;
    if (name === "assetName") {
      let result = pattern.test(value);
      if (result) {
        setSelectedAsset({
          ...selectedAsset,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setSelectedAsset({
          ...selectedAsset,
          [name]: value.replace(/[^a-zA-Z0-9\s]/g, "").toUpperCase(),
        });
      }
    } else if (name === "invoiceNumber") {
      setSelectedAsset({
        ...selectedAsset,
        [name]: value
          .replace(/[^A-Za-z0-9-/]/g, "")
          .trim()
          .toUpperCase()
          .slice(0, 15),
      });
    } else if (name === "purchasedBy") {
      setSelectedAsset({
        ...selectedAsset,
        [name]: value
          .replace(/[^a-zA-Z\s]/g, "")
          .replace(/\s+/g, " ")
          .trim()
          .toUpperCase(),
      });
    } else if (name === "quantity" || name === "price") {
      setSelectedAsset({
        ...selectedAsset,
        [name]: value.replace(/[^0-9]/g, ""),
      });
    } else {
      setSelectedAsset({
        ...selectedAsset,
        [name]: value,
      });
    }
  };

  const UpdateForm = async (e) => {
    e.preventDefault();
    console.log(selectedAsset);
    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/asset/UpdateAsset/${selectedAsset.Asset_Id}`,
          selectedAsset,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
              "content-type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          setSelectedAsset([]);
          fetchAssetList();
          setPreviewUrlUpdate("");
          setPreviewUrl("");
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    //console.log(formData);
    closeModal();
  };
  const handleDelete = async (Asset) => {
    //console.log(Asset)
    try {
      const confirm= window.confirm("Are you sure you want to delete this?")
      if(!confirm) return
      await axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/asset/DeleteAsset/${Asset.Asset_Id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            fetchAssetList();
          } else if (res.status === 500) {
            FailedMSG(res.data.message);
            window.location.reload();
          }
          fetchAssetList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(formData);
    formData['user']=username
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/asset/AddAsset`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
              "content-type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          fetchAssetList();
          SuccessMSG(res.data.message);
          setFormData([]);
          setPreviewUrl("");
          fetchAssetList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    //console.log(formData);
    closeModal();
    setFormData(InitState);
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <ToastContainer />
      {/* <Appbar username={passedState.username} rights={passedState.rights}></Appbar> */}
      <div className="Asset">
        <Menu username={username} rights={rights} i={"Asset"}></Menu>
        <div className="AssetPage">
          <p className="AssetHeadLabel">
            <button className="AssetBack" title="Back">
              <Link
                state={{ username: username, rights: rights }}
                to={"/AssetSetup"}
              >
                {" "}
                <FontAwesomeIcon
                  className="AssetBackicon"
                  icon={faArrowLeft}
                ></FontAwesomeIcon>
              </Link>
            </button>
            Asset
          </p>
          <div className="AssetHeaders">
            <div className="AssetRegSearch">
              <input
                className="AssetRegInput"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Asset Name"
              ></input>
              <button className="AssetSearchBtn">
                <FontAwesomeIcon
                  className="AssetRegSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
            <button className="NewAssetBtn" title="Add New" onClick={openModal}>
              Add New{" "}
              <FontAwesomeIcon
                className="AssetAddNewIcon"
                icon={faPlus}
              ></FontAwesomeIcon>
            </button>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleModalClose}
            contentLabel="Asset Form"
            center
            style={{
              overlay: {
                background: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              },
              content: {
                background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                position: "absolute",
                top: "40px",
                left: "25%",
                right: "25%",
                bottom: "40px",
                height: "auto",
                width: "50%",
                overflow: "scroll",
              },
            }}
          >
            <FontAwesomeIcon
              className="AssetFormCloseBtn"
              onClick={handleModalClose}
              title="Close"
              icon={faClose}
            ></FontAwesomeIcon>
            <p className="AssetFormHeadLabel">
              {selectedAsset?.Asset_Id ? "Edit Asset" : "Add Asset"}
            </p>
            <form
              className="AssetForm"
              onSubmit={selectedAsset?.Asset_Id ? UpdateForm : handleSubmit}
            >
              <div className="AssetFormFlex">
                <div className="Assetform1">
                  <div className="Assetform01">
                    <div className="AssetformFeildsr">
                      <label className="AssetFormLabels">
                        Asset Name <span>*</span>
                      </label>
                      <input
                        placeholder="Asset Name"
                        value={
                          selectedAsset
                            ? selectedAsset.assetName
                            : formData.assetName
                        }
                        onChange={selectedAsset ? handleUpdate : handleChange}
                        className="AssetFormInputs"
                        required
                        type="text"
                        name="assetName"
                      ></input>
                    </div>
                    <div className="AssetformFeildsr">
                      <label className="AssetFormLabels">Asset Type <span>*</span></label>
                      <select
                        className="AssetFormInputs2"
                        value={selectedAsset?.assetType || formData.assetType}
                        onChange={selectedAsset ? handleUpdate : handleChange}
                        name="assetType"
                      >
                        <option value={""}>Select</option>
                        {AssetTypeList.map((item, index) => (
                          <option key={index} value={item.Status}>
                            {item.Status}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="AssetformFeildsr">
                      <label className="AssetFormLabels">Asset Status <span>*</span></label>
                      <select
                        className="AssetFormInputs2"
                        value={
                          selectedAsset?.assetStatus || formData.assetStatus
                        }
                        onChange={selectedAsset ? handleUpdate : handleChange}
                        name="assetStatus"
                      >
                        <option value={""}>Select</option>
                        {AssetStatus.map((item, index) => (
                          <option key={index} value={item.Status_Ref}>
                            {item.Status_Ref}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="AssetForm0r">
                    <div className="AssetForm0rflex">
                      <div className="AssetFormPhoto">
                        {selectedAsset ? (
                          previewUrlUpdate === "" ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/${
                                selectedAsset.assetPhoto
                                  ? selectedAsset.assetPhoto.replace(/\\/g, "/")
                                  : ""
                              }`}
                              alt=""
                            ></img>
                          ) : (
                            <img src={previewUrlUpdate} alt=""></img>
                          )
                        ) : previewUrl === "" ? (
                          <img src={InitState.AssetPhoto} alt=""></img>
                        ) : (
                          <img src={previewUrl} alt=""></img>
                        )}
                      </div>
                      <div className="AssetformFeilds0l">
                        <label className="AssetFormLabels">Asset Photo</label>
                        <label
                          htmlFor="assetPhoto"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "30px",
                          }}
                          className="AssetFormPhotoInputs"
                        >
                          <FontAwesomeIcon icon={faCamera}></FontAwesomeIcon>
                        </label>
                        <input
                          className="AssetFormInputs"
                          id="assetPhoto"
                          onChange={
                            selectedAsset
                              ? handleUpdateFileChange
                              : handleFileChange
                          }
                          style={{ display: "none" }}
                          type="file"
                          name="AssetPhoto"
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="Assetform1">
                  <div className="AssetformFeilds">
                    <label className="AssetFormLabels">
                      Quantity <span>*</span>
                    </label>
                    <input
                      placeholder="Quantity"
                      value={selectedAsset?.quantity || formData.quantity}
                      onChange={selectedAsset ? handleUpdate : handleChange}
                      required
                      className="AssetFormInputs"
                      type="text"
                      name="quantity"
                    ></input>
                  </div>
                  <div className="AssetformFeilds">
                    <label className="AssetFormLabels">Price (₹) <span>*</span></label>
                    <input
                      placeholder="Price"
                      className="AssetFormInputs"
                      value={selectedAsset?.price || formData.price}
                      onChange={selectedAsset ? handleUpdate : handleChange}
                      type="text"
                      name="price"
                    ></input>
                  </div>
                </div>
                <div className="Assetform1">
                  <div className="AssetformFeilds">
                    <label className="AssetFormLabels">
                      Purchased Date <span>*</span>
                    </label>
                    <input
                      placeholder="01-Jan-1900"
                      className="AssetFormInputs"
                      max={today}
                      type={isDateInput[0] ? "date" : "text"}
                      onFocus={() => handleFocus(0)}
                      onBlur={() => handleFocus1(0)}
                      readOnly={!isDateInput[0]}
                      value={
                        selectedAsset
                          ? selectedAsset.purchasedDate
                            ? FormatDate(selectedAsset.purchasedDate)
                            : selectedAsset.purchasedDate
                          : formData.purchasedDate
                          ? FormatDate(formData.purchasedDate)
                          : formData.purchasedDate
                      }
                      onChange={(e) =>
                        selectedAsset
                          ? handleUpdateDate(e, 0)
                          : handleChangeDate(e, 0)
                      }
                      name="purchasedDate"
                    ></input>
                  </div>
                  <div className="AssetformFeilds">
                    <label className="AssetFormLabels">Expire Date </label>
                    <input
                      placeholder="01-Jan-1900"
                      className="AssetFormInputs"
                      min={today}
                      type={isDateInput[1] ? "date" : "text"}
                      onFocus={() => handleFocus(1)}
                      onBlur={() => handleFocus1(1)}
                      readOnly={!isDateInput[1]}
                      value={
                        selectedAsset
                          ? selectedAsset.expiredDate
                            ? FormatDate(selectedAsset.expiredDate)
                            : selectedAsset.expiredDate
                          : formData.expiredDate
                          ? FormatDate(formData.expiredDate)
                          : formData.expiredDate
                      }
                      onChange={(e) =>
                        selectedAsset
                          ? handleUpdateDate(e, 1)
                          : handleChangeDate(e, 1)
                      }
                      name="expiredDate"
                    ></input>
                  </div>
                </div>
                <div className="Assetform1">
                  <div className="AssetformFeilds">
                    <label className="AssetFormLabels">
                      Purchased By <span>*</span>
                    </label>
                    <input
                      placeholder="Purchased By"
                      value={selectedAsset?.purchasedBy || formData.purchasedBy}
                      onChange={selectedAsset ? handleUpdate : handleChange}
                      required
                      className="AssetFormInputs"
                      type="text"
                      name="purchasedBy"
                    ></input>
                  </div>
                  <div className="AssetformFeilds">
                    <label className="AssetFormLabels">Invoice Number</label>
                    <input
                      placeholder="Invoice Number"
                      className="AssetFormInputs"
                      value={
                        selectedAsset?.invoiceNumber || formData.invoiceNumber
                      }
                      onChange={selectedAsset ? handleUpdate : handleChange}
                      type="text"
                      name="invoiceNumber"
                    ></input>
                  </div>
                </div>
                <div className="Assetform1">
                  <div className="AssetformFeilds1">
                    <label className="AssetFormLabels">Description</label>
                    <textarea
                      placeholder="Description"
                      className="AssetFormInputs1"
                      value={selectedAsset?.description || formData.description}
                      onChange={selectedAsset ? handleUpdate : handleChange}
                      type="text"
                      name="description"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="AssetFormFooter">
                <div className="AssetFormFooterBtns">
                  <button
                    className="AssetFormSubmitBtn"
                    title="Confirm"
                    type="submit"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          <div className="AssetLists">
            {filteredAssetList.length < 1 ? (
              <p className="mx-auto" style={{textAlign:"center", width:"100%"}}>There are no Assets</p>
            ) : (
              filteredAssetList.map((items, index) =>
                items.Price ? (
                  <div key={index} className="AssetIndex">
                    <div className="AssetGrp0">
                      <div className="AssetIconGrp">
                        <FontAwesomeIcon
                          className="AssetUsesCircle"
                          icon={faUserCircle}
                        />
                      </div>
                      <div className="AssetGrp" style={{ width: "40%" }}>
                        <p className="AssetGrpLables">Id</p>
                        <p className="AssetGrpValues">{items.Asset_Id}</p>
                      </div>
                      <div className="AssetGrp" style={{ width: "80%" }}>
                        <p className="AssetGrpLables">Asset Name</p>
                        <p className="AssetGrpValues">{items.Asset_Name}</p>
                      </div>
                    </div>
                    <div className="AssetGrp">
                      <p className="AssetGrpLables">Asset Type <span>*</span></p>
                      <p className="AssetGrpValues">{items.Asset_Type}</p>
                    </div>
                    <div className="AssetGrp">
                      <p className="AssetGrpLables">Asset Price</p>
                      <p className="AssetGrpValues">{items.Price}</p>
                    </div>
                    <div className="AssetGrpBtn">
                      <FontAwesomeIcon
                        className="AssetEditIcon"
                        title="Edit"
                        icon={faEdit}
                        onClick={() => handleEdit(items)}
                      />
                      <FontAwesomeIcon
                        className="AssetDeleteIcon"
                        title="Delete"
                        onClick={() => handleDelete(items)}
                        icon={faTrash}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )
              )
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

/*

                {AssetList.length <1 ? <p>There is No Assets</p>:
                AssetList.map((items,index)=>{
                    return <><div className='AssetIndex'>
                    <div className='AssetGrp0'>
                      <div className='AssetIconGrp'><FontAwesomeIcon className='AssetUsesCircle' icon={faUserCircle}></FontAwesomeIcon></div>
                      <div  className='AssetGrp' style={{width:"40%"}}>
                      <p className='AssetGrpLables'>Id</p>
                      <p className='AssetGrpValues'>{items.Asset_Id}</p>
                      </div>
                      <div  className='AssetGrp'style={{width:"80%"}} >
                      <p className='AssetGrpLables'>Asset Name</p>
                      <p className='AssetGrpValues'>{items.Asset_Name}</p>
                      </div>
                    </div>
                    <div className='AssetGrp'>
                      <p className='AssetGrpLables'>Asset Contact</p>
                      <p className='AssetGrpValues'>{items.Contact1}</p>
                    </div>
                    <div className='AssetGrp'>
                      <p className='AssetGrpLables'>Aadhar Number</p>
                      <p className='AssetGrpValues'>{(items.Aadhar_Number)}</p>
                    </div>
                    <div className='AssetGrpBtn'>
                      <FontAwesomeIcon className='AssetEditIcon' title='Edit' icon={faEdit} onClick={()=>handleEdit(items)}></FontAwesomeIcon>
                      <FontAwesomeIcon className='AssetDeleteIcon' title='Delete' onClick={()=>handleDelete(items)} icon={faTrash}></FontAwesomeIcon>
                    </div>
                  </div>
                    </>
                })} 
                    */
